import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import cinstance from "../../Service/randomcinstance";
import usercinstance from "../../Service/usercinstance";
import giftcardcinstance from "../../Service/giftcardcinstance";
import web3 from "../../Service/web3";
import { NavBar, Hero, PopularGames, Benefits, GlobalCommunity, Working, Roadmap, Partners } from "../../Components/home";
import { networkID } from "../../../static/utils";
import {
  getConnectedAccount,
  getSavedAccount,
  connectWallet as triggerConnectWallet,
  subscribeToWalletEvents,
} from "../../../static/walletUtils";
import PartnersCarousel from "../../Components/partners-carousel/PartnersCarousel";
import "./Homepage.css";

const GameSection = ({ id, kicker, title, copy, href, cta, items, renderItem }) => {
  if (!items?.length) return null;

  return (
    <Box component="section" id={id} className="home-section">
      <Container className="home-container" maxWidth={false}>
        <Box className="home-panel">
          <Box className="home-section-head">
            <Box>
              <Typography component="p" className="home-kicker">{kicker}</Typography>
              <Typography component="h2" className="home-section-title">{title}</Typography>
              {copy ? <Typography component="p" className="home-section-copy">{copy}</Typography> : null}
            </Box>
            <Box component="a" href={href} className="home-cta">
              {cta}
              <span aria-hidden="true">→</span>
            </Box>
          </Box>
          <Grid container className="home-grid lottery-section2 text-center">
            {items.slice(0, 3).map(renderItem)}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Homepage = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [bookiesarray, setBookiesArray] = useState([]);
  const [lotterylist1, setLotterylist1] = useState([]);
  const [lotterylist2, setLotterylist2] = useState([]);
  const [lotterylist3, setLotterylist3] = useState([]);
  const [lotterylist4, setLotterylist4] = useState([]);
  const [giftcardlist, setGiftcardlist] = useState([]);
  const [partnerlist, setPartnerlist] = useState([]);
  const [partnerLogoData, setPartnerLogoData] = useState([]);
  const [giftcardLogoData, setGiftcardLogoData] = useState([]);

  const [buytotal, setBuytotal] = useState(0);
  const [totallotteries, setTotallotteries] = useState(0);
  const [bookies, setBookies] = useState(0);
  const [draws, setDraws] = useState(0);
  const [wins, setWins] = useState(0);
  const [net, setNet] = useState(false);
  const [warn, setWarn] = useState(false);
  const [walletAddress, setWalletAddress] = useState(() => getSavedAccount());

  const checkWallet = async () => {
    const account = await getConnectedAccount();
    setWalletAddress(account);
  };

  const handleConnectWallet = async () => {
    const res = await triggerConnectWallet();
    if (res.account) {
      setWalletAddress(res.account);
    }
  };

  const getglobaldata = async () => {
    const lotterylist1Data = [];
    const lotterylist2Data = [];
    const lotterylist3Data = [];
    const lotterylist4Data = [];
    const partnerlists1 = [];
    const partnerlists2 = [];
    const partnerlists3 = [];
    const partnerlists4 = [];
    const giftcardlistData = [];
    const partnerlistData = [];
    const bookiesarrayData = [];
    let counts = 0;

    setLoading(true);

    try {
      await Promise.all([
        cinstance.methods.totalSale().call().then((res) => setBuytotal(res)).catch(() => {}),
        cinstance.methods.totalDraws().call().then((res) => setDraws(res)).catch(() => {}),
        cinstance.methods.totalWinners().call().then((res) => setWins(res)).catch(() => {}),
        usercinstance.methods.ownerId().call().then(async (res) => {
          setBookies(res);
          for (let i = res - 1; i > 0; i--) {
            try {
              const responseAddress = await usercinstance.methods.organisationbyid(i).call();
              const response = await usercinstance.methods.organisationbyaddr(responseAddress).call();
              bookiesarrayData.push(response);
              setBookiesArray([...bookiesarrayData]);
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("error", error)),

        cinstance.methods.lotteryId().call().then(async (res) => {
          setTotallotteries(res);
          for (let i = 1; i < res; i++) {
            if (counts === 3) break;
            try {
              const response = await cinstance.methods.lotteries(i).call();
              if (response.status === "0" || response.status === "5") {
                if (response.lotteryType === "0" || response.lotteryType === 0) {
                  lotterylist1Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists1.push(responsee);
                    setLotterylist1([...lotterylist1Data]);
                  }).catch(() => {});
                } else if (response.lotteryType === "2" || response.lotteryType === 2) {
                  lotterylist2Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists2.push(responsee);
                    setLotterylist2([...lotterylist2Data]);
                  }).catch(() => {});
                } else if (response.lotteryType === "1" || response.lotteryType === 1) {
                  if (response?.lotteryId) lotterylist3Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists3.push(responsee);
                    setLotterylist3([...lotterylist3Data]);
                  }).catch(() => {});
                } else {
                  lotterylist4Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists4.push(responsee);
                    setLotterylist4([...lotterylist4Data]);
                  }).catch(() => {});
                }
              }

              lotterylist1Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist2Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist3Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist4Data.sort((a, b) => b.lotteryId - a.lotteryId);

              setLotterylist1([...lotterylist1Data]);
              setLotterylist2([...lotterylist2Data]);
              setLotterylist3([...lotterylist3Data]);
              setLotterylist4([...lotterylist4Data]);
              counts++;
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("res", error)),

        cinstance.methods.partnerId().call().then(async (res) => {
          for (let i = 0; i <= res; i++) {
            try {
              const responseAdd = await cinstance.methods.partnerids(i).call();
              const response = await cinstance.methods.partnerbyaddr(responseAdd).call();
              if (response.partnerAddress !== "0x0000000000000000000000000000000000000000") {
                partnerlistData.push(response);
                setPartnerlist([...partnerlistData]);
              }
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("res", error)),

        giftcardcinstance.methods.giftCardId().call().then(async (res) => {
          for (let i = 0; i < res; i++) {
            try {
              const response = await giftcardcinstance.methods.giftCards(i).call();
              const currentDT = moment().unix();
              if (response.isSold === false && response.expDate > currentDT) {
                giftcardlistData.push(response);
                setGiftcardlist([...giftcardlistData]);
              }
            } catch (error) {
              console.log("error", error);
            }
          }
          giftcardlistData.sort((a, b) => b.giftCardId - a.giftCardId);
          setGiftcardlist([...giftcardlistData]);
        }).catch((error) => console.log("error", error)),
      ]);

      setLoading(false);

      const scrollToSection = window.location.hash.slice(1);
      if (scrollToSection === "partners") {
        const partnerSection = document.getElementById("partner");
        if (partnerSection) {
          partnerSection.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_KEY;

    getglobaldata();
    checkWallet();

    if (web3 && web3.eth && web3.eth.net) {
      web3.eth.net.getId().then((netId) => {
        if (netId == networkID) {
          window.web3 = web3;
          setWarn(false);
        } else {
          setWarn(true);
          setNet(true);
        }
      }).catch(() => {});
    }

    const unsubscribe = subscribeToWalletEvents({
      onAccountsChanged: (acc) => setWalletAddress(acc),
      onChainChanged: () => checkWallet(),
      onDisconnect: () => setWalletAddress(""),
    });

    if (apiUrl) {
      axios.get(`${apiUrl}/s3imageupload/getAllPartnerLogos`)
        .then((response) => setPartnerLogoData(response?.data?.result || []))
        .catch(() => setPartnerLogoData([]));

      axios.get(`${apiUrl}/giftcardlogos/getAllGiftcardLogos`)
        .then((response) => setGiftcardLogoData(response?.data?.result || []))
        .catch(() => setGiftcardLogoData([]));
    }

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Box id="homePage" className="home-modern" sx={{ p: 0, m: 0 }}>
      <NavBar />
      
      <Hero
        variant="home"
        bookies={bookies === 0 ? "0" : Math.abs(bookies - 1)}
        lotteries={totallotteries === 0 ? "0" : Math.abs(totallotteries - 1)}
        buytotal={buytotal}
        draws={draws}
        wins={wins}
      />

      <PopularGames />
      
      <Benefits />

      <GlobalCommunity/>

      <Working/>

      <Roadmap/>

      <Partners />
    </Box>
  );
};

export default Homepage;